<template>
  <div class="ResetPersonelPass">
    <box :title="$t('nav-reset-password')">
      <div class="pa-2">
        <password-personel-search-panel @search="search" :accessTo="48" />
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn class="" color="primary" @click="btnResetPassWordClick">{{
          $t("resetPass")
        }}</v-btn>

        <v-btn class="" color="primary" @click="btnChangePassClick">{{
          $t("changePass")
        }}</v-btn>
      </v-card-actions>
    </box>
  </div>
</template>

<script>
import PasswordPersonelSearchPanel from "../../../components/admin/pass/PasswordPersonelSearchPanel.vue";
import EosToastType from "../../../model/EosToastType";
import ResultType from "../../../model/ResultType";
const PageMode = Object.freeze({
  Active: 1,
  Reset: 2,
});

export default {
  components: { PasswordPersonelSearchPanel },
  data() {
    return {
      args: {},
      btnResetPassWordVisible: false,
      btnDeActiveVisible: true,
      btnActiveVisible: true,
      perno: "",
      password: "",
      newPass: "",
      confirmPass: "",
    };
  },
  mounted() {
    this.pageLoad();
  },
  methods: {
    pageLoad() {
      this.args = this.$route.query;
      var mode = this.args.mode;
      if (mode == PageMode.Active) {
        this.btnResetPassWordVisible = false;
        this.btnDeActiveVisible = true;
        this.btnActiveVisible = true;
      } else {
        //this.btnResetPassWordVisible = !SecurityPolicy.IsActvieSecurity();
        this.btnDeActiveVisible = false;
        this.btnActiveVisible = false;
      }
    },
    search(params) {
      debugger
      this.perno = params.perno;
      this.newPass = params.newPass;
      this.confirmPass = params.confirmPass;
    },
    btnResetPassWordClick() {
      //var perno = this.$store.state.auth.auth.username;
      var params = {
        
        password: this.perno,
        perno: this.perno,
      };
      debugger
      if(this.perno==""){
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: "کاربری با این مشخصات یافت نشد",
        });
        return;
      }
     else{


      this.$store.dispatch("ChangePassword", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.$EosToast.show({
            type: EosToastType.success,
            msg: this.$t("operationSuccess"),
          });
        } else {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: result.error || this.$t("operationFailed"),
          });
        }
      });
    }
    },
    btnChangePassClick() {
      debugger
      if (
        !this.newPass ||
        !this.confirmPass ||
        this.newPass != this.confirmPass
      ) {
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: this.$t("errorConfirmPass"),
        });
        return;
      }else if(this.perno==""){
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: "کاربری با این مشخصات یافت نشد",
        });
        return;
      }
       else{
        this.password = this.newPass
      }

      var params = {
        password: this.password,
        perno: this.perno,
      };

      this.$store.dispatch("ChangePassword", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.$EosToast.show({
            type: EosToastType.success,
            msg: this.$t("operationSuccess"),
          });
        } else {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: result.error || this.$t("operationFailed"),
          });
        }
      });
    },
  },
};
</script>

<style>
</style>